export default [
    {
        title: 'Ana Sayfa',
        icon: 'HomeIcon',
        route: 'home',
    },
]
